import type { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import type TApiResult from "../../types/api/TApiResult";
import type { TAppFormError } from "../../types/TAppFormError";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFoundWithValidateErrors from "./config/tokenNotFoundWithValidateErrors";
import type { TAppMemberIconNicknameEditForm } from "../../types/TAppMemberIconNicknameEditForm";

export type TApiMemberIconNicknameUpdateValidateErrors = {
  validateErrors: TAppFormError<TAppMemberIconNicknameEditForm>[];
};

export const postMemberIconNicknameUpdate = async (params: {
  nickname: string;
  avatar_url: string;
}): Promise<TApiResult & TApiMemberIconNicknameUpdateValidateErrors> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFoundWithValidateErrors;

  return await client()
    .member.updateIconNickname.post({
      body: {
        nickname: params.nickname,
        avatar_url: params.avatar_url
      },
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      if (res && res?.body && res?.body?.message) {
        return {
          isSuccess: false,
          status: res.body.status_code,
          message: res.body.message,
          validateErrors: [],
        };
      }
      return {
        isSuccess: true,
        status: 200,
        message: "",
        validateErrors: [],
      };
    })
    .catch((e: AxiosError) => {
      const { status, message, errorMessages } = getErrorProperty(
        e,
        "postMemberIconNicknameUpdate"
      );
      if (!errorMessages) {
        return {
          isSuccess: false,
          status: status,
          message: message,
          validateErrors: [],
        };
      }

      const validateErrors: TAppFormError<TAppMemberIconNicknameEditForm>[] =
        errorMessages.details.map((d) => {
          return {
            key: d.key as TAppMemberIconNicknameEditForm,
            messages: d.values,
          };
        });

      return {
        isSuccess: false,
        status: status,
        message: "",
        validateErrors: validateErrors,
      };
    });
};
